import {CompetitionPageMetaDataModel} from "../../../models/competition-page.meta-data.model";
import {computed} from "mobx";

export class CompetitionHighlightsPageRouteMetaDataModel extends CompetitionPageMetaDataModel {
  @computed get pageTitle() {
    return this.staticTitle
  }

  @computed get description(): String {
    return this.staticDescription
  }

  get staticTitle() {
    const staticTitle: String = this.websiteTerms.COMPETITION_HIGHLIGHTS_TITLE_TEMPLATE.format({
      "COMPETITION_NAME": this.competitionName,
    });

    return staticTitle;
  }

  get staticDescription() {
    const staticDescription: String = this.websiteTerms.COMPETITION_HIGHLIGHTS_DESCRIPTION_TEMPLATE.format({
      "COMPETITION_NAME": this.competitionName,
      "SPORT_TYPE": this.competitionSportName,
    });

    return staticDescription;
  }
}